module.exports = __webpack_public_path__ + "static/media/p2008vid6.bff52d4f.mp4";